import { TabPanel } from '@mui/lab';
import styled from 'styled-components';

export const TimeTabPanel = styled(TabPanel)`
  padding: 0;
`;
